// src/App.tsx
import * as Sentry from '@sentry/react';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { EntitlementProvider } from './contexts/EntitlementContext';
import { DialogProvider } from './contexts/DialogContext';
import { ToastProvider } from './contexts/ToastContext';
import { BusyProvider } from './contexts/BusyContext';
import { TermsProvider } from './contexts/TermsContext';
import { SenhaObrigatoriaProvider } from './contexts/SenhaObrigatoriaContext';
import { OperacaoLoteProvider } from './contexts/OperacaoLoteContext';
import BusyOverlay from './components/common/BusyOverlay';
import AppErrorFallback from './components/common/AppErrorFallback';
import AppRoutes from './routes';
import './styles/global.css';

const App = () => (
  <AuthProvider>
    {/* EntitlementProvider dentro do AuthProvider: usa useAuth() para buscar
        /v1/entitlement/features no login e em reload. Eixo separado de permissões. */}
    <EntitlementProvider>
      <ThemeProvider>
        <DialogProvider>
          <ToastProvider>
            <BusyProvider>
              {/* TermsProvider dentro do ThemeProvider (usa useTheme) e envolvendo
                  as rotas: o modal de aceite é acionado pelo interceptor (bridge
                  singleton) e o ProtectedLayout consome useTerms() para o dropdown. */}
              <TermsProvider>
                {/* ErrorBoundary de topo (issue #22): crash de commit do React
                    causado por DOM mutado por extensão de tradução (removeChild/
                    insertBefore NotFoundError) degrada para um fallback com opção
                    de recarregar, em vez de tela branca. Via @sentry/react para
                    que o erro vire `handled` e seja capturado com contexto (fecha
                    o ponto cego da #21: hoje só `unhandled` chega ao Sentry). Fica
                    dentro dos providers e fora do Router — recuperação por reload. */}
                {/* SenhaObrigatoriaProvider (issue #27): gate de troca obrigatória
                    de senha; mesmo padrão de bridge singleton do TermsProvider.
                    Dentro de Auth/Theme (usa useAuth/useTheme) e envolvendo as rotas. */}
                <SenhaObrigatoriaProvider>
                  {/* OperacaoLoteProvider (issue #31): acompanha as ações em lote
                      que o backend aceita com 202 e devolve em segundo plano.
                      Fica ACIMA das rotas de propósito — o usuário sai da tela
                      que disparou a ação, e o aviso de conclusão precisa
                      alcançá-lo onde ele estiver. Dentro do DialogProvider
                      (usa showAlert). Nenhum provider existente mudou de ordem;
                      o ProtectedLayout não é tocado (premissa #10). */}
                  <OperacaoLoteProvider>
                    <Sentry.ErrorBoundary
                      fallback={({ resetError }) => <AppErrorFallback onReset={resetError} />}
                    >
                      <AppRoutes />
                    </Sentry.ErrorBoundary>
                  </OperacaoLoteProvider>
                </SenhaObrigatoriaProvider>
              </TermsProvider>
              {/* Após as rotas para garantir stacking acima do conteúdo;
                  z-index 99999 cobre Toast/AlertDialog (vide BusyOverlay.css). */}
              <BusyOverlay />
            </BusyProvider>
          </ToastProvider>
        </DialogProvider>
      </ThemeProvider>
    </EntitlementProvider>
  </AuthProvider>
);

export default App;
